var map = {
	"./Ambient.webp": "4112",
	"./Dark.webp": "3d57",
	"./Downtempo.webp": "d2af",
	"./Forest.webp": "5a5b",
	"./Full-On.webp": "1877",
	"./Goa.webp": "e75a",
	"./Hi-Tech.webp": "9cea",
	"./Progressive.webp": "34a4",
	"./Psy Dub.webp": "1d02",
	"./Psy Tech.webp": "d98d",
	"./Psybreaks.webp": "12cc",
	"./Psycore.webp": "235e",
	"./Suomi.webp": "091c",
	"./Twilight.webp": "2659",
	"./all_new.webp": "0ec1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f899";